// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 14,
  argument: "The evil of avarice: works of mercy are recommended, and the love of wisdom.",
  verses: [
    { n: 1, text: "Blessed is the man that hath not slipt by a word out of his mouth, and is not pricked with the remorse of sin." },
    { n: 2, text: "Happy is he that hath had no sadness of his mind, and who is not fallen from his hope." },
    { n: 3, text: "Riches are not comely for a covetous man and a niggard, and what should an envious man do with gold?" },
    { n: 4, text: "He that gathereth together by wronging his own soul, gathereth for others, and another will squander away his goods in rioting." },
    { n: 5, text: "He that is evil to himself, to whom will he be good? and he shall not take pleasure in his goods." },
    { n: 6, text: "There is none worse than he that envieth himself, and this is the reward of his wickedness." },
    { n: 7, text: "And if he do good, he doth it ignorantly, and unwillingly: and at the last he discovereth his wickedness." },
    { n: 8, text: "The eye of the envious is wicked: and he turneth away his face, and despiseth his own soul." },
    { n: 9, text: "The eye of the covetous man is insatiable in his portion of iniquity: he will not be satisfied till he consume his own soul, drying it up." },
    { n: 10, text: "An evil eye is towards evil things: and he shall not have his fill of bread, but shall be needy and pensive at his own table." },
    { n: 11, text: "My son, if thou have any thing, do good to thyself, and offer to God worthy offerings." },
    { n: 12, text: "Remember that death is not slow, and that the covenant of hell hath been shewn to thee: for the covenant of this world shall surely die." },
    { n: 13, text: "Do good to thy friend before thou die; and according to thy ability, stretching out thy hand, give to the poor." },
    { n: 14, text: "Defraud not thyself of the good day, and let not the part of a good gift overpass thee." },
    { n: 15, text: "Shalt thou not leave to others to divide by lot thy sorrows and labours?" },
    { n: 16, text: "Give and take, and justify thy soul." },
    { n: 17, text: "Before thy death work justice: for in hell there is no finding food." },
    { n: 18, text: "All flesh shall fade as grass, and as the leaf that springeth out on a green tree." },
    { n: 19, text: "Some grow, and some fall off: so is the generation of flesh and blood: one cometh to an end, and another is born." },
    { n: 20, text: "Every work that is corruptible, shall fail in the end: and the worker thereof shall go with it." },
    { n: 21, text: "And every excellent work shall be justified: and the worker thereof shall be honoured therein." },
    { n: 22, text: "Blessed is the man that shall continue in wisdom, and that shall meditate in his justice, and in his mind shall think of the all-seeing eye of God." },
    { n: 23, text: "He that considereth her ways in his heart, and hath understanding in her secrets, who goeth after her as one that traceth and stayeth in her ways:" },
    { n: 24, text: "He who looketh in at her windows, and hearkeneth at her door:" },
    { n: 25, text: "He that lodgeth near her house, and fastening a pin in her walls, shall set up his tent nigh unto her, where good things shall rest in his lodging for ever:" },
    { n: 26, text: "He shall set his children under her shelter, and shall lodge under her branches:" },
    { n: 27, text: "He shall be protected under her covering from the heat, and shall rest in her glory." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Mouth. He is perfect, James iii. 2.", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "Envious. Who will neither use his wealth himself, nor bestow it. The true use of riches is to take a sufficiency, and to relieve the poor.", attribution: "Calmet" }
    ] },
    { verse: 4, notes: [
      { text: "Gathereth. Greek, \"taketh from his,\" &c. (Haydock) — Such misers are continually derided, but will never be cured, Ecclesiastes ii. 18., and vi. 2. An old proverb says, \"The miser doth nothing right but when he dies.\"", attribution: "Calmet" }
    ] },
    { verse: 6, notes: [
      { text: "Envieth. By refusing himself the necessaries of life, he rejects God's gifts, and scandalizes his neighbour.", attribution: "Worthington" }
    ] },
    { verse: 7, notes: [
      { text: "Wickedness. Persisting covetous till death, as is commonly the case.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Offerings. Make a proper use of what God has bestowed.", attribution: "Calmet" }
    ] },
    { verse: 12, notes: [
      { text: "The covenant of hell. The decree by which all are to go down to the regions of death, (Challoner) which hell frequently denotes. (Haydock) — Under the old law, all went down into some part of hell. (Worthington) — Hath been. Greek, \"hath not,\" &c. We know not when we shall die, though all must taste of death, (Haydock) and therefore we must make haste to do good. (Menochius) — Shall, or \"is, he shall die the death,\" (Genesis ii. 17.) as the Greek has this sentence,", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "(Haydock) Certo veniunt ordine Parc�, Nulli jusso cessare licet.", attribution: "Sen.[Seneca?] Hercul." }
    ] },
    { verse: 15, notes: [
      { text: "Sorrows. Greek, \"toils,\" or what thou hast amassed with much care.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Take. Alms-deeds will ensure the remission of sins. This usury is lawful. We must also keep up a good society with our friends. (Calmet) — Justify. Greek, \"sanctify thy soul (17.) for.\" (Grabe) (Haydock) — Some read \"love,\" or divert thy soul by lawful amusements. The argument is addressed to Jews and Gentiles.", attribution: "Calmet" }
    ] },
    { verse: 20, notes: [
      { text: "End. The fruits of the Spirit are alone immortal,", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: ", and Galatians vi. 8.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Glory. As under the miraculous pillar, Exodus xxiv. 17. He who shall abide with wisdom shall have nothing to fear.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
